module.exports = __webpack_public_path__ + "media/images/riders/small/MYRIAM_NICOLE-c7ec429932d7ec3b9d36d1aa38f35446.png";